import React, { useState } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

const TextInput = ({dispatch, input: { ...inputProps }, meta: { touched, error } = {}, isLoading, label, disabled, style, required, mono, type, ...props}) => {
  const bare = !label;
  const isPassword = type === 'password';
  const [showPassword, setShowPassword] = useState(false);
  return(
      <div className={`pc-field${mono ? ' pc-field--mono' : ''}${bare ? ' pc-field--bare' : ''}`} style={style}>
        {label && (
          <label className="pc-field__label">
            {label}
            {required ? <i>*</i> : null}
          </label>
        )}
        <TextField
              error={!!(touched && error)}
              helperText={touched && error}
              {...inputProps}
              value={inputProps.value || ''}
              {...props}
              type={isPassword && !showPassword ? 'password' : (isPassword ? 'text' : type)}
              required={false}
              hiddenLabel
              size="small"
              disabled={isLoading || disabled}
              variant="outlined"
              fullWidth
              InputProps={isPassword ? {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={showPassword ? 'Скрыть' : 'Показать'}
                      onClick={() => setShowPassword((open) => !open)}
                      edge="end"
                      size="small"
                      tabIndex={-1}
                    >
                      {showPassword
                        ? <VisibilityOffOutlinedIcon sx={{ fontSize: '16px !important' }} />
                        : <VisibilityOutlinedIcon sx={{ fontSize: '16px !important' }} />
                      }
                    </IconButton>
                  </InputAdornment>
                )
              } : props.InputProps}
        />
      </div>
    )
}

const mapStateToProps = (state, props) =>{
  const { fetch } = state;
  return {
      isLoading: !!fetch.loading
  }
}

export default compose(
  connect(mapStateToProps),
)(TextInput);
